import { PayloadAction } from '@reduxjs/toolkit';
import { ProductState } from 'store/product/types';

interface SetForcedProductPreviewPayload {
  index: number;
  preview: string;
}

const setForcedProductPreviewReducer = (state: ProductState, action: PayloadAction<SetForcedProductPreviewPayload>) => {
  const { index, preview } = action.payload;
  state.forcedProductPreviews[index] = preview;
};

export default setForcedProductPreviewReducer;
